module.exports = Object.defineProperty;